import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentSelectedVenue: sessionStorage.getItem("managerVenueId")
    ? sessionStorage.getItem("managerVenueId")
    : "all",
  // 由于刷新页面后，request列有数据也要响，所以首次进来页面要请求一个接口
  // 这个接口会返回当前request列的所有订单，知道是哪个订单造成鬼叫
  // 就把它变成对象加入队列，所以ids其实也是有初始值的，初始值的格式
  // 由于刷新页面进来不需要显示未读数量，所以不需要记录得很精确
  /* 
    {
      scheduledOrderId: "123",
      venueId: "",
      behaviour: "",
      isForNow: "",
      popupType: 0,
      haveRead: true,
      sendTime: '',
      radarTime: '',
    },
  */
  // 把所有推送以订单id为唯一值存起来, 每个对象以订单id标明独立性
  // 场馆id也要存，但多个对象的场馆id可能是重复的，代表多个订单
  // 推送行为behaviour代表这个推送是属于哪一列的
  // 每次新推送来了，如果这个订单已存在，那么就要替换掉它
  // 订单数通过 behaviour + popupType 去判断
  // 是否标为已读haveRead，每次新的推送来了，到了新的列，根据popupType，1 2 12 4都标注为未读
  // 每次推送来了对订单进行标注，实际上每一列的未读数都会得到重新计算
  // 以及点击选项卡切换的时候，根据点击时候的传参 isForNow + behaviour，匹配到对应的订单
  // 把haveRead 状态改为true，标注为已读
  // 切换选项卡只修改haveRead的布尔值
  ids: [
    /*{
      scheduledOrderId: "123",
      venueId: "abc",
      behaviour: "Requests",
      isForNow: true,
      popupType: 1,
      haveRead: false,
      scheduledWay: 0,
      sendTime: '',
      radarTime: '',
    },*/
  ],
  // 如果新的推送来了，判断到跟上次记录的场馆id不一样
  // 那就是切换场馆了，localOrderNumbers可能重置过了
  // 也可能接口正在请求，所以设置未读数和订单数还是分开比较好
  forNowLocalOrderNumbers: [0, 0, 0, 0],
  forNowTotalOrders: 0,
  forNowUnread: [0, 0, 0, 0],
  forNowTotalUnread: 0,
  ringTimeOut: 0,
  allVenuesOrders: 0,
  allVenuesUnread: 0,
  missedNum: -1,
};

const unreadSlice = createSlice({
  name: "userInfo",
  initialState,
  reducers: {
    alterRingTimeout(state = initialState, action) {
      state.ringTimeOut = action.payload.number;
    },
    /* action 的格式{
        popupType: 1,
        sendTime: "1689559146824",
        venueId: "1631498782379249666",
        scheduledOrderId: '5445454545454'
    } */
    // 这是推送来了的时候进行处理
    alterUnreadIds(state = initialState, action) {
      let ids = JSON.parse(JSON.stringify(state.ids));
      // console.log("操作前的订单");
      // console.log(ids);
      // 新的推送所指向的订单id，之前是什么状态
      // 需要存下来，订单数才能做增减
      let existedObj = {} as any;
      let existedIndex = -1;
      let reduceTimes = 0;
      //console.log(ids);
      ids.forEach((obj: any, index: number) => {
        //console.log("obj.scheduledOrderId");
        //console.log(obj.scheduledOrderId);
        //console.log("action.payload.scheduledOrderId");
        //console.log(action.payload.scheduledOrderId);
        if (obj.scheduledOrderId === action.payload.scheduledOrderId) {
          existedObj = obj;
          existedIndex = index;
        }
        // 如果是雷达预定，pending有多个，用户选择了一个场馆，只会有一个推送过来，要根据
        // radarTime 把剩下的pending全部去掉
        if (
          action.payload.popupType === 2 &&
          action.payload.scheduledWay === 2 &&
          existedObj.popupType === 12 &&
          existedObj.radarTime === action.payload.radarTime &&
          obj.scheduledOrderId !== action.payload.scheduledOrderId
        ) {
          ids.splice(index, 1);
          // console.log("走这里");
          // console.log("action.payload.scheduledOrderId");
          // console.log(action.payload.scheduledOrderId);
          reduceTimes++;
        }
      });
      // console.log("existedObj");
      // console.log(existedObj);
      let behaviour = "";

      // 1 都是Requests，但是只有1才记录到未读数，5只记录订单数
      // 2 5 6 7 8都是Confirmed，但是只有2才记录到未读数，6 7 8 只记录订单数
      // 12 就是Pending
      if (action.payload.popupType === 1) behaviour = "Requests";
      else if (
        action.payload.popupType === 2 ||
        action.payload.popupType === 5 ||
        action.payload.popupType === 6 ||
        action.payload.popupType === 7 ||
        action.payload.popupType === 8 ||
        action.payload.popupType === 14
      )
        behaviour = "Confirmed";
      else if (action.payload.popupType === 12) behaviour = "Pending";
      else if (action.payload.popupType === 4) behaviour = "Closed";

      let generateNewObj = {
        scheduledOrderId: action.payload.scheduledOrderId,
        venueId: action.payload.venueId,
        behaviour: behaviour,
        scheduledWay: action.payload.scheduledWay,
        sendTime: action.payload.sendTime,
        radarTime: action.payload.radarTime,
        popupType: action.payload.popupType,
        duoblePlaces: action.payload.duoblePlaces ? true : false,
        haveRead:
          action.payload.popupType === 1 ||
          action.payload.popupType === 2 ||
          action.payload.popupType === 4 ||
          action.payload.popupType === 12
            ? false
            : true,
      };
      // console.log(existedIndex);
      if (existedIndex !== -1) {
        ids.splice(existedIndex, 1, generateNewObj);
      } else {
        ids.push(generateNewObj);
      }

      let allVenuesOrders = 0;
      let allVenuesUnread = 0;
      ids.forEach((obj: any, index: number) => {
        // if (obj.behaviour === "Requests" || obj.behaviour === "Confirmed")
        if (obj.behaviour === "Requests") allVenuesOrders++;
      });
      //console.log(ids);

      state.allVenuesOrders = allVenuesOrders;
      state.allVenuesUnread = allVenuesUnread;
      //console.log("state.allVenuesOrders");
      //console.log(state.allVenuesOrders);
      console.log("当前本地记录到的所有订单");
      console.log(ids);
      // console.log(state.currentSelectedVenue);
      // // console.log(action.payload.current);
      // 每次推送来了都要改一下未读数，需要知道当前选的是哪个id
      // 如果推送的场馆跟当前页面选中的场馆不一样，那就不需要继续往下走了
      if (
        state.currentSelectedVenue === action.payload.venueId ||
        state.currentSelectedVenue === "all"
      ) {
        let reqeustsUnread = 0;
        let pendingUnread = 0;
        let confirmedUnread = 0;
        /* scheduledOrderId: "123",
          venueId: "abc",
          behaviour: "Requests",
          isForNow: true,
          popupType: 1,
          haveRead: false, */
        ids.forEach((item: any) => {
          /* 未读数的算计 start ******************************************************/
          if (
            item.behaviour === "Requests" &&
            item.popupType === 1 &&
            !item.haveRead
          ) {
            reqeustsUnread++;
            // console.log("reqeustsUnread445454545454554");
          } else if (
            item.behaviour === "Pending" &&
            item.popupType === 12 &&
            !item.haveRead
          ) {
            pendingUnread++;
          } else if (
            item.behaviour === "Confirmed" &&
            item.popupType === 2 &&
            !item.haveRead
          ) {
            confirmedUnread++;
            // console.log("confirmedUnread445454545454554");
          }
          /* 未读数的算计 end ******************************************************/
        });
        let forNowUnreadResults = [
          reqeustsUnread,
          pendingUnread,
          confirmedUnread,
          0,
        ];
        state.forNowUnread = forNowUnreadResults;
        state.forNowTotalUnread = reqeustsUnread + confirmedUnread;
        // console.log("当前本地记录到的for now未读数");
        // console.log(forNowUnreadResults);
      }
      console.log("state.currentSelectedVenue");
      console.log(state.currentSelectedVenue);
      if (
        !(
          action.payload.venueId === state.currentSelectedVenue ||
          state.currentSelectedVenue === "all"
        )
      )
        return;
      /* 订单数的算计 start ******************************************************/
      // 已有订单，状态发生变化

      let nowReqeustsNum = state.forNowLocalOrderNumbers[0];
      let nowPendingNum = state.forNowLocalOrderNumbers[1];
      let nowConfirmedNum = state.forNowLocalOrderNumbers[2];
      let nowClosedNum = state.forNowLocalOrderNumbers[3];

      //console.log("existedObj");
      //console.log(existedObj);
      // console.log("action.payload");
      // console.log(action.payload);
      if (
        existedObj.scheduledOrderId &&
        existedObj.scheduledOrderId === action.payload.scheduledOrderId
      ) {
        // 情况1，已记录过该订单
        if (existedObj.scheduledOrderId) {
          // 情况1.2，订单位置没变，状态变了, for now的订单，requests - pending - confirmed - closed

          // 从for now 的request列变到for now的pending列
          // console.log("existedObj");
          // console.log(existedObj);
          // console.log(action.payload);
          if (
            existedObj.behaviour === "Requests" &&
            action.payload.popupType === 12
          ) {
            nowReqeustsNum--;
            nowPendingNum++;
          }
          // 从for now 的request列变到for now的confirmed列
          /*else if (
            existedObj.behaviour === "Requests" &&
            (action.payload.popupType === 2 ||
              action.payload.popupType === 5 ||
              action.payload.popupType === 6 ||
              action.payload.popupType === 7 ||
              action.payload.popupType === 8)
          ) {
            //console.log(nowReqeustsNum);
            nowReqeustsNum--;
            //console.log(nowReqeustsNum);
            nowConfirmedNum++;
          }*/
          // 从for now 的request列变到for now的closed列
          /*else if (
            existedObj.behaviour === "Requests" &&
            (action.payload.popupType === 4 || action.payload.popupType === 888)
          ) {
            nowReqeustsNum--;
            nowClosedNum++;
          }*/
          else if (
            existedObj.behaviour === "Requests" &&
            action.payload.popupType === 888
          ) {
            nowReqeustsNum--;
            nowClosedNum++;
          }
          // 从for now 的confirmed列变到for now的closed列
          /*else if (
            existedObj.behaviour === "Confirmed" &&
            action.payload.popupType === 4
          ) {
            nowConfirmedNum--;
            nowClosedNum++;
          }
          // 从for now 的pending列变到for now的closed列
          else if (
            existedObj.behaviour === "Pending" &&
            action.payload.popupType === 4
          ) {
            nowPendingNum--;
            nowClosedNum++;
          }*/
          // 从for now 的pending列变到for now的confirmed列
          /*else if (
            existedObj.behaviour === "Pending" &&
            (action.payload.popupType === 2 ||
              action.payload.popupType === 5 ||
              action.payload.popupType === 6 ||
              action.payload.popupType === 7 ||
              action.payload.popupType === 8)
          ) {
            nowPendingNum--;
            nowConfirmedNum++;
          }*/
          /*else if (
            existedObj.behaviour === "Pending" &&
            (action.payload.popupType === 2 || action.payload.popupType === 5)
          ) {
            nowPendingNum--;
            nowConfirmedNum++;
          }*/

          nowPendingNum =
            nowPendingNum - reduceTimes < 0 ? 0 : nowPendingNum - reduceTimes;
          // nowPendingNum = nowPendingNum - reduceTimes;
          console.log(nowReqeustsNum);
          state.forNowLocalOrderNumbers = [
            nowReqeustsNum,
            nowPendingNum,
            nowConfirmedNum,
            nowClosedNum,
          ];
          state.forNowTotalOrders = nowReqeustsNum + nowConfirmedNum;
          // console.log("已记录过该订单，且知道订单位置");
          // console.log(state.forNowLocalOrderNumbers);
        }
        // 情况2，通过线上的接口记录过该订单，但是不知道订单位置
        // 这是因为新订单是从本地没开始记录前就存在的（比如有新订单的情况下刷新了页面）
        // 这种情况只能去请求一下接口，获取当前场馆最新的订单数量
        else {
          // 这种情况已经在app.js请求过了
        }
      }
      // 新来了订单，直接加进去订单数
      else if (!existedObj.scheduledOrderId) {
        if (action.payload.popupType === 1) {
          nowReqeustsNum++;
        } else if (
          action.payload.popupType === 2
          //action.payload.popupType === 5 ||
          // action.payload.popupType === 6 ||
          // action.payload.popupType === 7 ||
          // action.payload.popupType === 8
        ) {
          nowConfirmedNum++;
        } else if (action.payload.popupType === 12) {
          nowPendingNum++;
        } else if (action.payload.popupType === 4) {
          nowClosedNum++;
        }
        nowPendingNum = nowPendingNum - reduceTimes;
        state.forNowLocalOrderNumbers = [
          nowReqeustsNum,
          nowPendingNum,
          nowConfirmedNum,
          nowClosedNum,
        ];
        // console.log(state.forNowLocalOrderNumbers);
        state.forNowTotalOrders = nowReqeustsNum + nowConfirmedNum;
      }
      /* 订单数的算计 end ******************************************************/
      state.ids = ids;
      console.log("new ids");
      console.log(ids);
      return state;
    },
    // 这是切换场馆了，重新获取订单数，并且计算本地记录的未读数
    alterOrdersNumber(state = initialState, action) {
      if (action.payload.venueId === "all" && action.payload.stop) {
        state.currentSelectedVenue = "all";
        state.allVenuesOrders = 0;
        state.allVenuesUnread = 0;
        state.forNowLocalOrderNumbers = [0, 0, 0, 0];
        state.forNowUnread = [0, 0, 0, 0];
        state.forNowTotalUnread = 0;
        state.forNowTotalOrders = 0;
      } else {
        // console.log(action.payload);
        state.currentSelectedVenue = action.payload.venueId;
        state.forNowLocalOrderNumbers = action.payload.now;
        state.forNowTotalOrders = action.payload.now[0] + action.payload.now[2];
      }
      let forNowReqeustsUnread = 0;
      let forNowPendingUnread = 0;
      let forNowConfirmedUnread = 0;

      let ids = state.ids;
      // console.log(ids);
      let tempIds = [] as any;

      // console.log(action.payload);
      if (action.payload.now && action.payload.now.length > 0)
        ids.forEach((item: any) => {
          if (
            action.payload.now[0] === 0 &&
            item.behaviour === "Requests" &&
            (action.payload.venueId === "all" ||
              action.payload.venueId === item.venueId)
          ) {
            return;
          }
          if (
            action.payload.now[2] === 0 &&
            item.behaviour === "Confirmed" &&
            (action.payload.venueId === "all" ||
              action.payload.venueId === item.venueId)
          ) {
            return;
          }
          tempIds.push(item);
        });
      //console.log(tempIds);
      tempIds.forEach((item: any) => {
        /* 未读数的算计 start ******************************************************/

        if (
          item.behaviour === "Requests" &&
          item.popupType === 1 &&
          !item.haveRead
        ) {
          forNowReqeustsUnread++;
        } else if (
          item.behaviour === "Pending" &&
          item.popupType === 12 &&
          !item.haveRead
        ) {
          forNowPendingUnread++;
        } else if (
          item.behaviour === "Confirmed" &&
          item.popupType === 2 &&
          !item.haveRead
        ) {
          forNowConfirmedUnread++;
        }

        /* 未读数的算计 end ******************************************************/
      });
      let forNowUnreadResults = [
        forNowReqeustsUnread,
        forNowPendingUnread,
        forNowConfirmedUnread,
        0,
      ];
      //console.log("forNowReqeustsUnread");
      //console.log(forNowReqeustsUnread);
      //console.log("forNowConfirmedUnread");
      //console.log(forNowConfirmedUnread);
      state.forNowUnread = forNowUnreadResults;
      state.forNowTotalUnread = forNowReqeustsUnread + forNowConfirmedUnread;
      // state.ids = tempIds;
      if (action.payload.premise === "decideIfRing") {
        state.allVenuesOrders = action.payload.now[0];
      }
      return state;
    },
    alterOrdersNumberTotal(state = initialState, action) {
      state.allVenuesOrders = action.payload.now[0];
      return state;
    },
    // 这是切换选项卡了，点击遍历ids，把对应列的数据全部haveRead设置true
    setRead(state = initialState, action) {
      console.log(action.payload.target);
      let ids = JSON.parse(JSON.stringify(state.ids));
      let forNowReqeustsUnread = state.forNowUnread[0];
      let forNowPendingUnread = state.forNowUnread[1];
      let forNowConfirmedUnread = state.forNowUnread[2];
      if (action.payload.target === "Requests") forNowReqeustsUnread = 0;
      if (action.payload.target === "Pending") forNowPendingUnread = 0;
      if (action.payload.target === "Confirmed") forNowConfirmedUnread = 0;

      //console.log(action.payload.target);
      ids.forEach((item: any) => {
        /* 未读数的算计 start ******************************************************/

        if (
          action.payload.target === "Requests" &&
          item.behaviour === "Requests"
        ) {
          item.haveRead = true;
          // forNowReqeustsUnread = 0;
        } else if (
          action.payload.target === "Pending" &&
          item.behaviour === "Pending"
        ) {
          item.haveRead = true;
          // forNowPendingUnread = 0;
        } else if (
          action.payload.target === "Confirmed" &&
          item.behaviour === "Confirmed"
        ) {
          item.haveRead = true;
          // forNowConfirmedUnread = 0;
        }

        /* 未读数的算计 end ******************************************************/
      });
      let forNowUnreadResults = [
        forNowReqeustsUnread,
        forNowPendingUnread,
        forNowConfirmedUnread,
        0,
      ];
      state.forNowUnread = forNowUnreadResults;
      // console.log("走这里了吗");
      state.ids = ids;
      state.forNowTotalUnread = forNowReqeustsUnread + forNowConfirmedUnread;
      return state;
    },
    setInitialIds(state = initialState, action) {
      // console.log("action.payload.ids");
      // console.log(action.payload.ids);
      state.ids = action.payload.ids;
      return state;
    },
    // 清掉雷达的订单
    clearScheduledWay(state = initialState, action) {
      // console.log("清掉");
      // console.log(action.payload.who);
      let ids = JSON.parse(JSON.stringify(state.ids));
      // console.log("state.ids");
      // console.log(ids);
      let left = JSON.parse(JSON.stringify([]));
      ids.forEach((item: any, index: number) => {
        // console.log("item.sendTime");
        // console.log(item.sendTime);
        if (
          action.payload.who === item.radarTime &&
          item.behaviour !== "Confirmed"
        ) {
          //
        } else {
          left.push(item);
        }
      });
      state.ids = ids;
      let forNowReqeustsUnread = 0;
      let forNowPendingUnread = 0;
      let forNowConfirmedUnread = 0;

      // console.log(left);
      let nowReqeustsNum = 0;
      let allNowReqeustsNum = 0;
      let nowPendingNum = 0;
      let nowConfirmedNum = state.forNowLocalOrderNumbers[2];
      let nowClosedNum = state.forNowLocalOrderNumbers[3];

      left.forEach((item: any) => {
        /* 未读数的算计 start ******************************************************/
        if (
          item.behaviour === "Requests" &&
          item.popupType === 1 &&
          !item.haveRead &&
          (item.venueId === action.payload.venueId ||
            action.payload.venueId === "all")
        ) {
          forNowReqeustsUnread++;
        } else if (
          item.behaviour === "Pending" &&
          item.popupType === 12 &&
          !item.haveRead &&
          (item.venueId === action.payload.venueId ||
            action.payload.venueId === "all")
        ) {
          forNowPendingUnread++;
        } else if (
          item.behaviour === "Confirmed" &&
          item.popupType === 2 &&
          !item.haveRead &&
          (item.venueId === action.payload.venueId ||
            action.payload.venueId === "all")
        ) {
          forNowConfirmedUnread++;
        }
        if (item.behaviour === "Requests") {
          allNowReqeustsNum++;
          if (
            item.venueId === action.payload.venueId ||
            action.payload.venueId === "all"
          )
            nowReqeustsNum++;
        } else if (
          item.behaviour === "Pending" &&
          (item.venueId === action.payload.venueId ||
            action.payload.venueId === "all")
        ) {
          nowPendingNum++;
        } else if (
          item.behaviour === "Closed" &&
          (item.venueId === action.payload.venueId ||
            action.payload.venueId === "all")
        ) {
          nowClosedNum++;
        }

        state.forNowLocalOrderNumbers = [
          nowReqeustsNum,
          nowPendingNum,
          nowConfirmedNum,
          nowClosedNum,
        ];
        state.forNowTotalOrders = allNowReqeustsNum + nowConfirmedNum;
        /* 未读数的算计 end ******************************************************/
      });
      let forNowUnreadResults = [
        forNowReqeustsUnread,
        forNowPendingUnread,
        forNowConfirmedUnread,
        0,
      ];
      state.forNowUnread = forNowUnreadResults;

      state.forNowTotalUnread = forNowReqeustsUnread + forNowConfirmedUnread;
      state.forNowLocalOrderNumbers = [
        nowReqeustsNum,
        nowPendingNum,
        nowConfirmedNum,
        nowClosedNum,
      ];
      state.forNowTotalOrders = allNowReqeustsNum + nowConfirmedNum;

      state.ids = left;
      let allVenuesOrders = 0;
      left.forEach((obj: any, index: number) => {
        // if (obj.behaviour === "Requests" || obj.behaviour === "Confirmed")
        if (obj.behaviour === "Requests") allVenuesOrders++;
      });
      state.allVenuesOrders = allVenuesOrders;
      return state;
    },
    // 点击move to archive，清掉指定订单
    clearSpecificOrder(state = initialState, action) {
      let ids = JSON.parse(JSON.stringify(state.ids));
      let left = [] as any;
      ids.forEach((item: any) => {
        if (item.scheduledOrderId !== action.payload.scheduledOrderId)
          left.push(item);
      });
      state.ids = left;

      let allVenuesOrders = 0;
      left.forEach((obj: any, index: number) => {
        // if (obj.behaviour === "Requests" || obj.behaviour === "Confirmed")
        if (obj.behaviour === "Requests") allVenuesOrders++;
      });
      state.allVenuesOrders = allVenuesOrders;
      return state;
    },
    // 点击move to archive，清掉指定订单
    clearSpecificOrderNow(state = initialState, action) {
      let ids = JSON.parse(JSON.stringify(state.ids));
      let left = [] as any;
      ids.forEach((item: any) => {
        if (item.scheduledOrderId !== action.payload.scheduledOrderId)
          left.push(item);
      });
      state.ids = left;
      let nowReqeustsNum = state.forNowLocalOrderNumbers[0];
      let nowPendingNum = state.forNowLocalOrderNumbers[1];
      let nowConfirmedNum = state.forNowLocalOrderNumbers[2];
      let nowConfirmedClosed = state.forNowLocalOrderNumbers[3];
      console.log(action.payload.from);
      if (action.payload.from === "Closed") nowConfirmedClosed--;
      if (action.payload.from === "Confirmed") nowConfirmedNum--;
      state.forNowLocalOrderNumbers = [
        nowReqeustsNum,
        nowPendingNum,
        nowConfirmedNum,
        nowConfirmedClosed,
      ];
      let allVenuesOrders = 0;
      left.forEach((obj: any, index: number) => {
        // if (obj.behaviour === "Requests" || obj.behaviour === "Confirmed")
        if (obj.behaviour === "Requests") allVenuesOrders++;
      });
      state.allVenuesOrders = allVenuesOrders;
      return state;
    },
    setMissedNum(state = initialState, action) {
      state.missedNum = action.payload.num;
      return state;
    },
    reduceMissedNum(state = initialState, action) {
      let current = JSON.parse(JSON.stringify(state.missedNum));
      state.missedNum = current - 1;
      return state;
    },
    clearSpecificOrders(state = initialState, action) {
      let ids = JSON.parse(JSON.stringify(state.ids));
      let leftIds = [] as any;
      ids.forEach((item: any) => {
        if (
          action.payload.type === item.behaviour &&
          (action.payload.venueId === item.venueId ||
            action.payload.venueId === "all")
        )
          return;
        leftIds.push(item);
      });
      let nowReqeustsNum = state.forNowLocalOrderNumbers[0];
      let nowPendingNum = state.forNowLocalOrderNumbers[1];
      let nowConfirmedNum = state.forNowLocalOrderNumbers[2];
      let nowClosedNum = state.forNowLocalOrderNumbers[3];

      state.forNowLocalOrderNumbers = [
        action.payload.type === "Requests" ? 0 : nowReqeustsNum,
        action.payload.type === "Pending" ? 0 : nowPendingNum,
        action.payload.type === "Confirmed" ? 0 : nowConfirmedNum,
        nowClosedNum,
      ];
      let tempforNowLocalOrderNumbers = [
        action.payload.type === "Requests" ? 0 : nowReqeustsNum,
        action.payload.type === "Pending" ? 0 : nowPendingNum,
        action.payload.type === "Confirmed" ? 0 : nowConfirmedNum,
        nowClosedNum,
      ];

      let forNowReqeustsUnread = 0;
      let forNowPendingUnread = 0;
      let forNowConfirmedUnread = 0;

      leftIds.forEach((item: any) => {
        /* 未读数的算计 start ******************************************************/
        if (
          item.behaviour === "Requests" &&
          item.popupType === 1 &&
          !item.haveRead
        ) {
          forNowReqeustsUnread++;
        } else if (
          item.behaviour === "Pending" &&
          item.popupType === 12 &&
          !item.haveRead
        ) {
          forNowPendingUnread++;
        } else if (
          item.behaviour === "Confirmed" &&
          item.popupType === 2 &&
          !item.haveRead
        ) {
          forNowConfirmedUnread++;
        }

        /* 未读数的算计 end ******************************************************/
      });
      let forNowUnreadResults = [
        forNowReqeustsUnread,
        forNowPendingUnread,
        forNowConfirmedUnread,
        0,
      ];
      state.forNowUnread = forNowUnreadResults;

      state.forNowTotalUnread = forNowReqeustsUnread + forNowConfirmedUnread;
      state.ids = leftIds;
      if (
        action.payload.venueId === "all" &&
        tempforNowLocalOrderNumbers[0] === 0
      ) {
        state.allVenuesOrders = 0;
      }
      return state;
    },
  },
});

export const {
  alterUnreadIds,
  alterOrdersNumber,
  setRead,
  setInitialIds,
  alterRingTimeout,
  clearScheduledWay,
  clearSpecificOrder,
  clearSpecificOrderNow,
  alterOrdersNumberTotal,
  setMissedNum,
  clearSpecificOrders,
  reduceMissedNum,
} = unreadSlice.actions;

export default unreadSlice.reducer;
